<div [ngClass]="{ 'client-information-card': isClientInformation }">
  <div
    [style]="disableClick ? 'cursor: default' : ''"
    class="jobs-card note-card"
    (click)="openEditNoteModal()"
  >
    <div class="title">
      <div class="header">
        <span>{{
          isClientInformation ? "Client Information" : note?.title
        }}</span>

        <div class="icons-wrapper gap-1">
          <span class="fs-6 fw-normal mx-1" style="white-space: nowrap;">
            {{ note?.last_edited_dt || clientInformation?.last_edited_dt | amDateFormat: 'll' }}
          </span>
          <img
            *ngIf="isClientInformation && clientInformation?.last_edited_by"
            class="avatar"
            title="{{
              clientInformation?.last_edited_by
                ? 'Last edited by '
                : 'Created by '
            }} {{ clientInformation?.last_edited_by?.full_name }} on {{
              clientInformation?.last_edited_dt | amDateFormat: 'MMM DD'
            }}"
            [src]="clientInformation?.last_edited_by?.pictureUrl"
          />

          <img
            *ngIf="!isClientInformation"
            class="avatar"
            title="{{
              note?.last_edited_by ? 'Last edited by ' : 'Created by '
            }} {{ note?.last_edited_by?.full_name }} on {{
              note?.last_edited_dt | amDateFormat: 'MMM DD'
            }}"
            [src]="
              note?.last_edited_by?.pictureUrl ?? note?.created_by.pictureUrl
            "
          />

          @if (
            [PINNED_STATUS_CHOICES.TODO, PINNED_STATUS_CHOICES.DONE].includes(
              note?.pinned_item?.pinned_status
            )
          ) {
            <ds-pin
              [hovering]="false"
              [type]="pinTypeNote"
              [identifier]="note?.uuid"
              [model]="note"
              [pin]="note?.pinned_item"
              [company]="{ id: note?.company }"
              [showAssignedTo]="false"
            />
          }
        </div>
      </div>
      <p
        style="font-size: 12px; font-weight: 200; margin-top: 20px"
        *ngIf="isClientInformation && !clientInformation.content"
      >
        Click here to add Client Information
      </p>
    </div>
    <div
      *ngIf="note?.content || clientInformation?.content"
      class="card-content"
      [innerHTML]="
        (isClientInformation ? clientInformation.content : note?.content)
          | keepHtml
      "
    ></div>
  </div>
</div>
